import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {CopilotIndexOld} from './copilot/_variants/CopilotIndexOld'
import {CopilotIndexU24} from './copilot/_variants/CopilotIndexU24'

export function CopilotIndex() {
  const {siteUniverse24} = useRoutePayload<{siteUniverse24: boolean}>()
  if (siteUniverse24) {
    return <CopilotIndexU24 />
  } else {
    return <CopilotIndexOld />
  }
}

try{ CopilotIndex.displayName ||= 'CopilotIndex' } catch {}